import React, {useEffect,useState} from 'react';
import {Box, Button,Stack,TextField,Typography} from "@mui/material";

import {exerciceOptions, fetchData} from "../utils/fetchData";
import HorizontalScrollbar from './HorizontalScrollbar';

const SearchExercices = ({setExercices, bodyPart, setBodyPart}) => {

    const [search, setsearch] = useState("");
    const [bodyParts, setBodyParts] = useState([])

    useEffect(() => {
      const fetchExercicesData = async () => {
          const bodyPartsData = await fetchData(
            'https://exercisedb.p.rapidapi.com/exercises/bodyPartList',
            exerciceOptions);

            setBodyParts(['all', ...bodyPartsData]);
      }

      fetchExercicesData();
    }, [])

    const handleSearch = async ()=>{
        if(search){
            const exercicesData = await fetchData(
                'https://exercisedb.p.rapidapi.com/exercises',
                exerciceOptions);

            const searchdExercices = exercicesData.filter( exercice => exercice.name.toLowerCase().includes(search)
                                                            || exercice.target.toLowerCase().includes(search)
                                                            || exercice.equipment.toLowerCase().includes(search)
                                                            || exercice.bodyPart.toLowerCase().includes(search)
                                                            );

            setsearch('');
            setExercices(searchdExercices);
        }

    }

  return (
    <Stack alignItems={'center'} mt="37px" justifyContent={"center"} p="20px">
        <Typography fontWeight={700} sx={{fontSize:{lg:"44px",xs:'30px'}}} mb={'50px'} textAlign="center">
            Des exercices géniaux <br /> à connaître 
        </Typography>
        <Box position="relative" mb={'72px'}>
            <TextField
                sx={{
                    input:{fontWeight:"700", border:"none", borderRadius:"4px"},
                    width:{lg:'900px', xs:'350px'},
                    backgroundColor:'#fff',
                    borderRadius:"40px"
                }}
                height="76px" value={search} type="text" placeholder='Rechercher des Exercices' 
                onChange={ e => setsearch(e.target.value.toLowerCase()) } />
                <Button className="search-btn"
                   sx={{
                       bgcolor:"#FF2625",
                       color:"#fff",
                       textTransform:"none",
                       width:{lg:"175px", xs:"90px"},
                        fontSize:{lg:"20px", xs:"14px"},
                        height:"56px",
                        position:"absolute",
                        right:"0"
                   }} 
                   onClick={handleSearch}
                >Rechercher</Button>
        </Box>
        <Box sx={{position:'relative', width:'100%', p:'20px'}}>
            <HorizontalScrollbar data={bodyParts}
                bodyPart={bodyPart} setBodyPart = {setBodyPart} isBodyParts />
        </Box>
    </Stack>
  )
}

export default SearchExercices